import attributeService from "../../services/attributeSertvice";
import {
    ATTRIBUTE_GET_FAILURE,
    ATTRIBUTE_GET_REQUEST,
    ATTRIBUTE_GET_SUCCESS,
     } from "./actionTypes";
export const fetchAttributeAction = (authUserId,token) => {
   
    return async (dispatch) => {
      dispatch({ type: ATTRIBUTE_GET_FAILURE });
      try {
        const response = await attributeService.fetchAttribute(authUserId,token);
        const { data } = response;
        dispatch({ type: ATTRIBUTE_GET_SUCCESS, payload: data });
        return data; 
      } catch (error) {
        dispatch({ type: ATTRIBUTE_GET_REQUEST, error: error.message });
        return Promise.reject(error); 
      }
    };
  };